module.exports = __webpack_public_path__ + "07_hair_black.8caf8397.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/07_hair_black.png
// module id = /aqf
// module chunks = 0